// Copyright 2024, Imprivata, Inc.  All rights reserved.

import React from 'react';
import ReactDOM from 'react-dom/client';
import '@imprivata-cloud/design-system/style.css';
import './index.less';
import { App } from './App';

const rootElement = document.getElementById('root') as HTMLElement;
const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
